<form [formGroup]="form">
<div class="modal-header">
  <h4 class="modal-title">{{'login.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p class="font-weight-bold" *ngIf="showHeaderLogin">{{'login.header' | translate}}</p>
    <p [innerHTML]="'newproject.welcomActionSelection.loginLabel' | translate"></p>
    <div *ngIf="cdcEnabled" class="mb-3 row d-flex justify-content-center">
      <div class="col-md-6">
        <a href="javascript:void(0)" data-gatm="login.loginButton"
            (click)="cdcLogin()" [class.event-disabled]="!cdcInitialized"
            class="btn btn-secondary btn-lg px-2 col-lg-12 d-flex align-items-center gap-2">
            <app-svg-icon type="user"/>
            {{(cdcInitialized ? 'login.label.login' : 'login.customer_data_cloud_loading') | translate}}
        </a>
      </div>
    </div>
    <div *ngIf="cdcEnabled" class="row d-flex justify-content-center">
      <div class="col-md-8 d-flex justify-content-around">
        <a *ngIf="cdcEnabled" class="u" data-gatm="login.signup_button" href="javascript:void(0)" (click)="cdcSignUp()"
            appActionLogId="login.signup_button">
            <i class="mdi mdi-chevron-right pr-1"></i>
            {{'login.signup_part.signup_button.label' | translate}}
        </a>
      </div>
    </div>
    <section *ngIf="loginNotifications?.length > 0">
      <hr class="my-4">
      <!-- login system notifications -->
      <section class="login-info-notice">
        <div *ngFor="let notification of loginNotifications" class="row">
          <div class="col-lg-12" [innerHTML]="getNotificationText(notification)"></div>
        </div>
        <a *ngIf="hasTemporaryLoginNotifications" href="javascript:void(0)" (click)="confirmNotifications()" class="btn btn-primary">
          {{'global.label.ok' | translate}}
      </a>
      </section>
    </section>
    <hr *ngIf="(cdcEnabled || loginNotifications?.length > 0) && localAuthenticationEnabled" class="my-4">
    <div *ngIf="localAuthenticationEnabled" class="mb-3 row d-flex justify-content-center">
      <div class="col-md-6">
        <input appInputAutoFocus
               type="text"
               name="username"
               class="form-control col-mb-6"
               spellcheck="false"
               (keyup.enter)="onEnter()"
               [placeholder]="('login.login_part.username.placeholder' | translate) + ': *'"
               formControlName="username">
      </div>
    </div>
    <div *ngIf="localAuthenticationEnabled" class="row d-flex justify-content-center">
      <div class="col-md-6">
        <input type="password"
               name="password"
               class="form-control col-mb-6"
               (keyup.enter)="onEnter()"
               [placeholder]="('login.login_part.password.placeholder' | translate) + ': *'"
               formControlName="password">
      </div>
    </div>
    <div *ngIf="localAuthenticationEnabled && cdcEnabled" class="row">&nbsp;</div>
    <div *ngIf="localAuthenticationEnabled && cdcEnabled" class="mb-3 row d-flex justify-content-center">
      <div class="col-md-6">
        <button class="btn btn-primary" data-testid="login-button" type="button" (click)="login()">{{'login.label.login' | translate}}</button>
      </div>
    </div>
    <div *ngIf="localAuthenticationEnabled && !cdcEnabled" class="row">&nbsp;</div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel"
          type="button"
          (click)="close()">{{'global.label.cancel' | translate}}
  </button>
  <button *ngIf="localAuthenticationEnabled && !cdcEnabled" class="btn btn-primary btn-forward"
          id="login_button"
          data-testid="login-button"
          type="button"
          (click)="login()">{{'login.label.login' | translate}}
  </button>
</div>
</form>
